import React from 'react';
import { Box, Typography } from '@mui/material';
import { AddIcon } from 'icons/materialIcons';

const CreateCard = ({ onCreateCardClick }) => {
  return (
    <Box
      onClick={onCreateCardClick}
      sx={{
        cursor: 'pointer',
        padding: '5px',
        backgroundColor: '#ffffff',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '40%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px',
        minHeight: '320px',
        boxSizing: 'border-box',

      }}
    >
      <Box
        sx={{
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          backgroundColor: '#f7f7f7',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '16px',
        }}
      >
        <AddIcon sx={{ fontSize: '40px', color: '#3e69d6' }} />
      </Box>

      <Typography
        variant="h6"
        sx={{
          fontWeight: 500,
          fontSize: '1.3rem',
          textAlign: 'center',
          color: '#000',
          marginBottom: '16px',
        }}
      >
        Create New Card
      </Typography>
    </Box>
  );
};

export default CreateCard;
